export default __webpack_public_path__ + "static/media/330_portfolio03-jp-web.92fe9bd4.png";